export const arrowRightBlackSVG = `<svg width="100%" height="100%" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.333333 0.833374L4.5 5.00004L0.333333 9.16671V0.833374Z" fill="#323232"/>
</svg>
`;
